<template>
    <div v-if="user">
        <b-row>
            <b-col>
                <o-card :title="$t('core.welcome')">
                    <strong>
                        {{ $t('core.welcome') }} {{ user.name }}
                    </strong>

                    <div class="mt-3">
                        <router-link v-if="hasPermission(['GET api/sandoz/apo-one/contracts'])" :to="{ name: 'sandoz.apo_one.contracts'}"
                                     class="btn btn-primary mb-2 mr-1" tag="div">
                            <fa icon="file-contract" size="lg"/>
                            <br>
                            {{ $t('sandoz.apo_one_contracts') }}
                        </router-link>
                        <router-link v-if="hasPermission(['GET api/system/apo_one_addresses'])" :to="{ name: 'system.apo_one_address_list'}"
                                     class="btn btn-primary mb-2 mr-1" tag="div">
                            <fa icon="table" size="lg"/>
                            <br>
                            {{ $t('core.apo_one_addresses') }}
                        </router-link>

<!--                    Disable for now
                        <router-link v-if="hasPermission(['GET api/sandoz/apo_one_users'])" :to="{ name: 'system.apo_one_user_list'}"
                                     class="btn btn-primary mb-2 mr-1" tag="div">
                            <fa icon="users" size="lg"/>
                            <br>
                            {{ $t('core.apo_one_users') }}
                        </router-link>-->
                    </div>
                </o-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    methods: {
        hasPermission(item) {
            let result = true
            let permissions = item
            let user = this.user
            if (!user.is_super_user && permissions) {
                permissions.forEach((permission) => {
                    if (!user.routePermissions.includes(permission)) {
                        result = false
                    }
                })
            }
            return result
        }
    }
}
</script>
